import * as React from 'react';
import { ApolloProvider } from '@apollo/client';
import { useGraphqlClient } from './useGraphqlClient';

export interface AuthenticatedApolloProvider {}

export const AuthenticatedApolloClient: React.FC<AuthenticatedApolloProvider> = ({ children }) => {
  const client = useGraphqlClient();

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
